module.exports = __webpack_public_path__ + "img/sld_mccb_box.bba22dc7.svg";